export const DEFAULT_SERVICE_TIMEOUT = 30000;

export enum DEVICES_WIDTHS {
  MOBILE = 839,
}

export enum FUNDS_LIST {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export enum DEFAULT_VALUES {
  NO_DATA_FROM_SERVICE = '--',
}

export enum SUBSCRIPTIONS_TYPES {
  A = 'A',
  M = 'M',
  R = 'R',
  T = 'T',
}

export enum SUBSCRIPTIONS_DISCOUNTS {
  U = 'U',
  P = 'P',
}

export enum APV_ROUTES {
  HOME = '/home/ccv/home',
}

export const PRODUCT_TYPE = 'CCV';
export const FUNCTIONALITY = 'INTERNET';
export const APP_USER = 'APPAHORROPERIODICO';
export const DEFAULT_EXECUTIVE = {
  checkDigit: '9',
  rut: '1',
};
export const ERROR_INVALID_EXEC_RUT = 'AU40';

export const MONTHS_IN_SPANISH = {
  0: 'Enero',
  1: 'Febrero',
  2: 'Marzo',
  3: 'Abril',
  4: 'Mayo',
  5: 'Junio',
  6: 'Julio',
  7: 'Agosto',
  8: 'Septiembre',
  9: 'Octubre',
  10: 'Noviembre',
  11: 'Diciembre',
};

export const MAIL_REGEX = /^[^@\s]+@[^\s@]+\.[^\s@]+$/;

export enum SERVICE_STATUS_CODES {
  OK = 'AU00',
}

export const CONTRIBUTIONS_CCV_6 = 'contributions_ccv_6';
export const ACTIVE_SUBSCRIPTIONS_CCV = 'active_subscriptions_ccv';

export const GENERIC_KEY_SUCCESS = 'gnrc_k_scs';

export const IS_FAILED_SUBSCRIPTION = 'is_failed_subscription';
export const ACCOUNTS = 'accounts';

export const ENABLE_CCV_CAV_ACCOUNT_DETAIL_GO_BACK_BTN = "enable_ccv_cav_account_detail_go_back_btn";
